var map = {
	"./areas/monitors/event-log-monitor/event-log-monitor-page/route": "./src/app/areas/monitors/event-log-monitor/event-log-monitor-page/route.ts",
	"./areas/monitors/service-monitor/service-monitor-page/route": "./src/app/areas/monitors/service-monitor/service-monitor-page/route.ts",
	"./areas/monitors/system-monitor/SystemMonitorPage/route": "./src/app/areas/monitors/system-monitor/SystemMonitorPage/route.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/app sync recursive route$";